<script setup>
import axios from 'axios';
import { onMounted, ref } from "vue";
import { FilterMatchMode,FilterOperator } from '@primevue/core/api';
import { pVentasRequest, findAllRequest,updateInvoicesRequest, ErrosInvoicesRequest } from '../api/invoices';
import { invocer } from '../api/invoicer';
import { municipality } from '../api/technicalAnnex';

import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Select from 'primevue/select';
import DatePicker from 'primevue/datepicker';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
const { format,subDays } = require("date-fns");


// Fecha actual
const today = new Date();
const formattedToday = format(today, "MM/dd/yyyy");

// Fecha del día anterior
const yesterday = subDays(today, 1);
const formattedYesterday = format(yesterday, "MM/dd/yyyy");
const filters = ref();
const initFilters = () => {
  filters.value = {
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
     nombre: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
     nombre_archivo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
     consecutivo : { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
     totalFactura : { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
  };
}

initFilters();

const toast = useToast();
const confirm = useConfirm();
const activeSpinner = ref(false)
const dataSource = ref([]);
const invoicerSouce = ref([]);
const pventas = ref([]);
const selectedPventa = ref('');
const data_from = ref(formattedYesterday);
const data_to = ref(formattedToday);
const selectedInvoicer = ref(null);
const columns = [
  { field: 'facturador', header: 'Facturador' },
  { field: 'fecha_creacion', header: 'Fecha' },
  { field: 'hora_creacion', header: 'Hora' },
  { field: 'fecha_timbrado', header: 'Fecha Timbrado' },
  { field: 'hora_timbrado', header: 'Hora Timbrado' }
];

//ObjetsArray Municipios && Departamentos
const munDep = ref([]);
const municipalities = ref([]);
const departments = ref([]);
const selectedDeparment = ref(null);
const selectedCodeDeparment = ref(null);
const selectedMunicipaly = ref(null);
const selectedCodeMunicipaly = ref(null);

const urlsConfig = {
    api2: [
        'mimos-hospitalpablotobonuribe',
        'mimos-cityplaza',
        'mimos-primaveraurbana',
        'mimos-citymedica',
        'mimos-vivavillavicencio',
        'mimos-ipiales',
        'mimos-parqueguarne',
        'mimos-estrella',
        'mimos-jardin',
        'mimos-florida',
        'mimos-santafe',
        'mimos-fabricato3',
        'mimos-puertadelnorte',
        'mimos-eurolafrontera',
        'mimos-florencia',
        'mimos-santuario',
        'mimos-plazabeillin',
        'mimos-vegasplaza',
        'macehticos-santafe',
        'mimos-aventura',
        'mimos-carmendeviboral',
        'macehticos-fabricato',
        'macehticos-sannicolas',
        'macehticos-mayorca',
        'macehticos-plazabeillin',
        'mimos-vivawajira',
        'macehticos-mallotraparte',
        'mimos-bosqueplaza',
        'mimos-eltesoro',
        'mimos-aeropuertopalmira',
        'mimos-bicentenario',
        'macehticos-lacentral',
        'mimos-plazadelrio',
        'macehticos-aventura',
        'mimos-guatapuri',
        'macehticos-terminaldelnorte',
        'macehticos-aguacatala',
        'macehticos-llanogrande',
        'mimos-nuestrouraba',
        'mimos-fabricato2',
        'mimos-jauladelangel',
        'mimos-laestacion',
        'mimos-plazaflora',
        'mimos-multicentro',
        'mimos-lemont',
        'mimos-parqueexplora',
        'mimos-florida2',
        'mimos-diamante',
        'macehticos-diamante',
        'mimos-distritovera'
    ], 
};

const formatDate = (date) => {
  if (date != undefined) {
    const fecha = new Date(date);
    return format(fecha, "yyyy-MM-dd");
  }else {
    return null;
  }
}

const resetFilter = () => {
  data_from.value = null;
  data_to.value = null;
  selectedPventa.value = '';
  selectedInvoicer.value = null;
  selectedDeparment.value = null;
  selectedCodeDeparment.value = null;
  selectedMunicipaly.value = null;
  selectedCodeMunicipaly.value = null;
  loadInfo();
}

const loadInfo = async () => {
  const date_from = formatDate(data_from.value);
  const date_to = formatDate(data_to.value);
  let data = { date_from , date_to, pventa: selectedPventa.value, invoicer: selectedInvoicer.value }
  loadInvoices(data);
}

const loadNameByPventa = async () => {
  try {
    let data = {department : selectedCodeDeparment.value,municipality: selectedCodeMunicipaly.value}
    let result = await pVentasRequest(data)
    pventas.value = result.data.data;
    selectedPventa.value = pventas.value[25].nombre;
  } catch (error) {
    console.log(error);
  }
}

const loadMucipaly = async () => {
  let municipalitiesAndDepartments = await municipality();
  munDep.value = municipalitiesAndDepartments.data.data;
  department();
}

const loadInvoices = async (data) => {
  activeSpinner.value = true;
  try {
    let result = await findAllRequest(data);
    dataSource.value = result.data.data;
  } catch (error) {
    console.log(error);
  } finally {
    activeSpinner.value = false;
  }
}

const bell = async (data) => {
  const formData = new URLSearchParams();
  formData.append("filename", data.nombre_archivo);
  formData.append("pventa", data.nombre);
  
  try {
        let response = null;
        if (urlsConfig.api2.includes(data.nombre)) {
          response = await axios.post("https://fe-dian.pos-fenix.com/SendInvoice.php", formData);
        } else {
          response = await axios.post("https://fe-dian.fenix-pos.com/SendInvoice.php", formData);
        }
        if (response.data.isValid == "true" || response.data.isValid == true) {
            let value = {
                id: data.id,
                cufe: response.data.xmlDocumentKey,
                filename: data.nombre_archivo,
                fecha: new Date(),
                name: data.nombre,
                pdf: `${data.nombre}/${data.nombre_archivo}/${response.data.xmlFileName}.pdf`,
                xml: `${data.nombre}/${data.nombre_archivo}/${response.data.xmlFileName}.xml`
            }
            await updateInvoicesRequest(value);
            loadInvoices();
            toast.add({ severity: 'info', summary: 'Timbrada', detail: 'Correctamente', life: 4000 });
        }

        if (response.data.isValid == "false" || response.data.isValid == false) {
            let value = {
                id: data.id,
                status: response.data.statusDescription == null ? '500' : response.data.statusDescription,
                error: response.data.ErrorMessage == null ? response.data.msn : response.data.ErrorMessage,
                factura: data.nombre_archivo,
                fecha: new Date(),
            }
            await ErrosInvoicesRequest(value)
            toast.add({ severity: 'error', summary: 'Error', detail: response.data.ErrorMessage, life: 4000 });
        }
    } catch (error) {
      toast.add({ severity: 'info', summary: 'Error Server', detail: error.message, life: 4000 });
    }
}

const showPdf = (data) => {
  if (urlsConfig.api2.includes(data.nombre)) {
    const url = `https://mimos.pos-fenix.com${data.url_pdf}`;
    window.open(url, '_blank');
  } else {
    const url = `https://mimos.fenix-pos.com${data.url_pdf}`;
    window.open(url, '_blank');
  }
}

const showCufe = (data) => {
    confirm.require({
        message: data.cufe,
        header: 'CUFE',
        icon: 'pi pi-bookmark-fill',
        acceptProps: {
            label: 'Consultar Dian'
        },
        rejectProps: {
            label: 'Close',
            severity: 'danger'
        },
        accept: () => {
          const url = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${data.cufe}`
          window.open(url, '_blank');
        }       
    });
};

const showPaper = (data) => {
  if (urlsConfig.api2.includes(data.nombre)) {
    const url = `https://mimos.pos-fenix.com/factura/${data.nombre}/${data.nombre_archivo}.pdf`;
    window.open(url, '_blank');
  } else {
    const url = `https://mimos.fenix-pos.com/factura/${data.nombre}/${data.nombre_archivo}.pdf`;
    window.open(url, '_blank');
  }
}

const sourceInvoicer = async() => {
  const invoicers = await invocer();
  invoicerSouce.value = invoicers.data.data;
}

const department = () => {
  departments.value = munDep.value.reduce((acc, curr) => {
    const existing = acc.find(item => item.departamento === curr.nombre_departamento);
    return existing ? acc : [...acc, { codigo: curr.codigo_departamento, departamento: curr.nombre_departamento }];
  }, []);
}

const municipalityAndCode = () => {
  selectedCodeDept();
  selectedCodeMunicipaly.value = null;
  municipalities.value = [];
  const code = selectedCodeDeparment.value
  municipalities.value = munDep.value
  .filter(item => item.codigo_departamento === code)
  .map(item => ({
    codigo: item.codigo_municipio,
    municipio: item.nombre_municipio
  }));
  loadNameByPventa();
}

const selectedCodeDept = () => {
  let code = selectedDeparment.value.codigo != undefined ? selectedDeparment.value.codigo : selectedDeparment.value;
  selectedCodeDeparment.value =  code
}

const selectedCodeMun = () => {
  let code = selectedMunicipaly.value.codigo != undefined ? selectedMunicipaly.value.codigo : selectedMunicipaly.value;
  selectedCodeMunicipaly.value = code;
  loadNameByPventa()
}

onMounted(async () => {
  await loadNameByPventa();
  await loadInfo();
  sourceInvoicer();
  loadMucipaly();
});

</script>
<template>
  <div class="py-4 container-fluid">
    <Toast />
    <ConfirmDialog></ConfirmDialog>
    <div class="d-flex justify-content-center align-content-center">
      <div class="col-lg-12 col-md-6 col-12">
        <div class="mb-3 card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <label for="selectedDeparment" class="form-label">Departamento</label>
                <Select  v-model="selectedDeparment" @change="municipalityAndCode" :options="departments" filter optionLabel="departamento" class="form-select form-select-sm" />
              </div>
              <div class="col-md-4">
                <label for="selectedMunicipaly" class="form-label">Municipio</label>
                <Select  v-model="selectedMunicipaly" @change="selectedCodeMun" :options="municipalities" filter optionLabel="municipio" class="form-select form-select-sm" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Punto De Venta</label>
                <Select  v-model="selectedPventa" :options="pventas" filter optionValue="nombre" optionLabel="nombre" class="form-select form-select-sm" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Fecha Inicio</label><br>
                <DatePicker class="input" v-model="data_from" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Fecha Final</label><br>
                <DatePicker class="input" v-model="data_to" />
              </div>
              <div class="col-md-4">
                <button class="btn btn-link mt-4 py-3" @click="loadInfo">
                  <i class="fa fa-search" aria-hidden="true" />
                </button>
                <button class="btn btn-link mt-4 py-3" @click="resetFilter">
                  <i class="pi pi-refresh" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card z-index-2">
      <div class="row p-4">
        <div class="col-md-3">
          <IconField>
            <InputIcon><i class="pi pi-search" /></InputIcon>
            <InputText class="input" v-model="filters['global'].value" placeholder="Buscar..." />
          </IconField>    
        </div>
        <div class="col-md-3">
          <Select  
            v-model="selectedInvoicer" 
            :options="invoicerSouce"
            placeholder="Facturador..."
            filter 
            optionValue="id_facturador" 
            optionLabel="razon_social"  
            class="form-select form-select-sm"  
            @change="loadInfo"
          />
        </div>
      </div>
      <div class="col-lg-12 mb-lg-0 mb-4">
        <div class="card">
          <div class="mt-3 px-2">
            <div v-if="activeSpinner" class="flex justify-content-center align-items-center text-center mb-5">
              <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
            </div>
            <DataTable 
              v-if="!activeSpinner"
              class="m-3" 
              :value="dataSource" 
              :paginator="true" 
              :rows="5"
              :rowsPerPageOptions="[5, 10, 20, 50]" 
              :filters="filters"
              stripedRows 
              resizableColumns 
              columnResizeMode="fit" 
              showGridlines 
              tableStyle="min-width: 50rem"
              v-model:filters="filters" 
              filterDisplay="menu"
              :globalFilterFields="['nombre','nombre_archivo','facturador']"
            >
              <Column field="nombre" header="Pventa" style="min-width: 12rem">
                <template #body="{ data }">
                  {{ data.nombre }}
                </template>
                <template #filter="{ filterModel }">
                    <InputText v-model="filterModel.value" type="text" placeholder="Search by nombre" />
                </template>
              </Column>
              <Column field="nombre_archivo" header="Factura" style="min-width: 12rem">
                <template #body="{ data }">
                  {{ data.nombre_archivo }}
                </template>
                <template #filter="{ filterModel }">
                    <InputText v-model="filterModel.value" type="text" placeholder="Search by factura" />
                </template>
              </Column>
              <Column field="consecutivo" header="Consecutivo" style="min-width: 12rem">
                <template #body="{ data }">
                  {{ data.consecutivo }}
                </template>
                <template #filter="{ filterModel }">
                    <InputText v-model="filterModel.value" type="text" placeholder="Search by consecutivo" />
                </template>
              </Column>
              <Column field="totalFactura" header="Total" style="min-width: 12rem">
                <template #body="{ data }">
                  {{ data.totalFactura }}
                </template>
                <template #filter="{ filterModel }">
                    <InputText v-model="filterModel.value" type="text" placeholder="Search by total" />
                </template>
              </Column>
              <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header" sortable ></Column>
              <Column :exportable="false" header="Opciones" style="min-width: 1rem">
                <template #body="slotProps" >
                    <Button v-if="slotProps.data.cufe == ''" icon="pi pi-bell" outlined rounded class="mr-2" title="TIMBRAR" severity="info" @click="bell(slotProps.data)" />
                    <Button v-if="slotProps.data.cufe != ''" icon="pi pi-eye" outlined rounded class="mr-2" title="CUFE" severity="info" @click="showCufe(slotProps.data)" />
                    <Button icon="pi pi-file-pdf" outlined rounded class="mr-2" title="PDF" severity="danger" @click="showPdf(slotProps.data)" />
                    <Button icon="pi pi-file-o" outlined rounded class="mr-2" title="PAPEL" severity="primary" @click="showPaper(slotProps.data)" />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>

.input {
  height: 3rem !important;
  width: 100%;
}
</style>
